import { inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { map, mergeMap, catchError, switchMap, exhaustMap } from 'rxjs/operators'
import { of } from 'rxjs'
// import { ToastrService } from 'ngx-toastr'
// import { Store } from '@ngrx/store'
// import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import {
  blockDepartment,
  blockDepartmentFailure,
  blockDepartmentSuccess,
  createDepartment,
  createDepartmentFailure,
  createDepartmentSuccess,
  deleteDepartment,
  deleteDepartmentFailure,
  deleteDepartmentSuccess,
  loadDepartments,
  loadDepartmentsFailure,
  loadDepartmentsSuccess,
  unblockDepartment,
  unblockDepartmentFailure,
  unblockDepartmentSuccess,
  updateDepartment,
  updateDepartmentFailure,
  updateDepartmentSuccess
} from './department.actions'
import { DepartmentService } from '../../services/department.service'
import { ToastrService } from 'ngx-toastr'
import { Store } from '@ngrx/store'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'

export const loadDepartments$ = createEffect(
  (actions$ = inject(Actions), departmentService = inject(DepartmentService)) =>
    actions$.pipe(
      ofType(loadDepartments),
      switchMap(
        (
          action // Use action.filter here
        ) =>
          departmentService.getDepartments(action.params, action.page, action.limit).pipe(
            map(res =>
              loadDepartmentsSuccess({
                totalCount: res.totalCount,
                departments: res.departments
              })
            ),
            catchError(error => of(loadDepartmentsFailure({ error: error.message })))
          )
      )
    ),
  { functional: true }
)

export const createDepartment$ = createEffect(
  (
    actions$ = inject(Actions),
    departmentService = inject(DepartmentService),
    toastr = inject(ToastrService), // Inject the ToastrService
    store = inject(Store),
    modalService = inject(NgbModal)
  ) =>
    actions$.pipe(
      ofType(createDepartment),
      exhaustMap(({ departmentName, businessId }) =>
        departmentService.createDepartment({ departmentName, businessId }).pipe(
          map(created => {
            // Dispatch the success action
            const successAction = createDepartmentSuccess({ department: created })

            // Show a success message using Toastr
            toastr.success('Department created successfully!', 'Success')
            // store.dispatch(loadDepartments({ params: null, page: 1, limit: 10 }))
            modalService.dismissAll()
            return successAction
          }),
          catchError(error => {
            // Optionally, show an error message
            toastr.error(error.error.message, 'Error')
            return of(createDepartmentFailure({ error }))
          })
        )
      )
    ),
  { functional: true, dispatch: true }
)

export const updateDepartment$ = createEffect(
  (
    actions$ = inject(Actions),
    departmentService = inject(DepartmentService),
    toastr = inject(ToastrService),
    store = inject(Store),
    modalService = inject(NgbModal)
  ) =>
    actions$.pipe(
      ofType(updateDepartment),
      exhaustMap(({ id, departmentName, businessId }) =>
        departmentService
          .updateDepartment({
            id,
            departmentName,
            businessId
          })
          .pipe(
            map(updatedDepartment => {
              toastr.success('Department updated successfully!', 'Success')

              // Dispatch loadBusinessById after the update is successful
              // store.dispatch(loadDepartments({ params: null }))
              modalService.dismissAll()
              // Dispatch success action to update the store
              return updateDepartmentSuccess({ department: updatedDepartment })
            }),
            catchError(error => {
              toastr.error(error.error.message, 'Error')

              return of(updateDepartmentFailure({ error }))
            })
          )
      )
    ),
  { functional: true }
)

export const blockDepartment$ = createEffect(
  (
    actions$ = inject(Actions),
    departmentService = inject(DepartmentService),
    store = inject(Store),
    toastr = inject(ToastrService)
  ) =>
    actions$.pipe(
      ofType(blockDepartment),
      exhaustMap(action =>
        departmentService.blockDepartment(action.id, action.disabled).pipe(
          map(res => {
            // const actionToDispatch =
            // console.log('Dispatching blockDepartmentSuccess:', { department: res })
            // store.dispatch(actionToDispatch) // Dispatch the action
            //dispatch block  business success action
            if (action.disabled === true) {
              // Fixed typo here
              toastr.success('Department inactive successfully!')
            } else {
              toastr.success('Department active successfully!')
            }
            // store.dispatch(loadDepartments({ params: null, page: 1, limit: 10 }))
            return blockDepartmentSuccess({ department: res })
            // return blockBusinessSuccess({ business: res })
            // return blockBusinessSuccess({ id: action.id })
          }),
          catchError(error => {
            toastr.error('Failed to block department: ' + error.message)
            return of(blockDepartmentFailure({ error }))
          })
        )
      )
    ),
  { functional: true }
)

export const unblockDepartment$ = createEffect(
  (actions$ = inject(Actions), departmentService = inject(DepartmentService)) =>
    actions$.pipe(
      ofType(unblockDepartment),
      exhaustMap(action =>
        departmentService.unblockDepartment(action.id).pipe(
          map(() => unblockDepartmentSuccess({ id: action.id })),
          catchError(error => of(unblockDepartmentFailure({ error })))
        )
      )
    ),
  { functional: true } // ✅ Required for functional effects
)

export const deleteDepartment$ = createEffect(
  (
    actions$ = inject(Actions),
    departmentService = inject(DepartmentService),
    toastr = inject(ToastrService)
  ) =>
    actions$.pipe(
      ofType(deleteDepartment),
      exhaustMap(action =>
        departmentService.deleteDepartment(action.id).pipe(
          map(() => {
            toastr.success('Department deleted successfully!')
            return deleteDepartmentSuccess({ id: action.id })
          }),
          catchError(error => {
            toastr.error('Failed to delete Department: ' + error.message)
            return of(deleteDepartmentFailure({ error }))
          })
        )
      )
    ),
  { functional: true }
)

export const departmentEffects = {
  loadDepartments$,
  createDepartment$,
  updateDepartment$,
  blockDepartment$,
  deleteDepartment$,
  unblockDepartment$
}
